import { Component } from "react";
import { graphql } from "gatsby";
import styles from "./admission-block.module.less";
import RichTextRenderer from "components/block-elements/rich-text-renderer/rich-text-renderer";
import { extract, PrimaryButtonLink } from "@parksandresorts/core";

export default class AdmissionBlock extends Component {
  constructor(props) {
    super(props);

    this.buttonLabel = extract(this.props, "button.title", null);
    this.internalUrl = extract(this.props, "button.internalLink.slug", null);
    this.externalUrl = extract(this.props, "button.externalUrl", null);

    this.buttonUrl = this.internalUrl ? this.internalUrl : this.externalUrl;
  }

  render() {
    return (
      <section
        className="block block--floating-padding block--max-width-narrow"
        data-contentful-id={this.props.contentful_id}
      >
        <div className={styles.wrapper}>
          {this.props.headline && <h2 className={["h1", styles.title].join(" ")}>{this.props.headline}</h2>}
          {this.props.body && <RichTextRenderer richTextData={this.props.body} />}
          {this.props.button && (
            <PrimaryButtonLink
              className={["waves-effect", styles.button].join(" ")}
              label={this.buttonLabel}
              url={this.buttonUrl}
            />
          )}
        </div>
      </section>
    );
  }
}

export const fragmentAdmissionBlock = graphql`
  fragment AdmissionBlock on ContentfulAdmissionBlock {
    contentful_id
    id
    headline
    body {
      raw
    }
    button {
      title
      internalLink {
        slug
      }
      externalUrl
    }
  }
`;
